import { BaseMenu } from "./base-menu";

export class ClientMenu extends BaseMenu {
    club: boolean = false;
    client: boolean = false;
}
